import React from "react";
import { Carousel } from "antd";

const HomeTestimonal = () => {
  return (
    <div className="test text-center">
      <div className="mx-auto max-w-screen-xl">
        <div className="testContent py-14">
          <div className="title">
            <h3>Testimonal</h3>
          </div>
          <div className="description mb-4">
            <p>
              Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi
              amet consectetuer lorem ipsum dolor ngồi amet consectetuer lorem
              ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi amet
              consectetuer lorem ipsum dolor ngồi amet consectetuer lorem ipsum
              dolor ngồi amet consectetuer lorem ipsum dolor{" "}
            </p>
          </div>
          <div className="testBody flex">
            <div className="testBodyLeft">
              <Carousel slidesToShow={1}>
                <div className="carouselItem">
                  <div className="carouselItemContent">
                    <div className="blueCircle">
                      <img
                        src={"./img/asset.png"}
                        alt="asset"
                        className="imgPerson"
                      />
                    </div>
                    <div className="name my-3">
                      <p>Nguyen Ngoc Anh</p>
                      <p>Lorem ipsum dolor amet consectetuer</p>
                    </div>
                    <div className="description">
                      <p>
                        Lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer
                      </p>
                    </div>
                  </div>
                </div>
                <div className="carouselItem">
                  <div className="carouselItemContent">
                    <div className="blueCircle">
                      <img
                        src={"./img/asset.png"}
                        alt="asset"
                        className="imgPerson"
                      />
                    </div>
                    <div className="name my-3">
                      <p>Nguyen Ngoc Anh</p>
                      <p>Lorem ipsum dolor amet consectetuer</p>
                    </div>
                    <div className="description">
                      <p>
                        Lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer
                      </p>
                    </div>
                  </div>
                </div>
                <div className="carouselItem">
                  <div className="carouselItemContent">
                    <div className="blueCircle">
                      <img
                        src={"./img/asset.png"}
                        alt="asset"
                        className="imgPerson"
                      />
                    </div>
                    <div className="name my-3">
                      <p>Nguyen Ngoc Anh</p>
                      <p>Lorem ipsum dolor amet consectetuer</p>
                    </div>
                    <div className="description">
                      <p>
                        Lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer lorem ipsum dolor
                        amet consectetuer lorem ipsum dolor amet consectetuer
                        lorem ipsum dolor amet consectetuer
                      </p>
                    </div>
                  </div>
                </div>
              </Carousel>
            </div>
            <div className="testBodyRight">
              <Carousel slidesToShow={1}>
                <div className="carouselItemRight">
                  <div className="carouselItemRightContent">
                    <div className="grid grid-cols-5 grid-rows-3">
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carouselItemRight">
                  <div className="carouselItemRightContent">
                    <div className="grid grid-cols-5 grid-rows-3">
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carouselItemRight">
                  <div className="carouselItemRightContent">
                    <div className="grid grid-cols-5 grid-rows-3">
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/WordPress-logotype-wmark-white.png"} />
                      </div>
                      <div>
                        <img src={"./img/Wikimedia_Commons_logo_white.png"} />
                      </div>
                      <div>
                        <img src={"./img/UNESCO_logo_white.png"} />
                      </div>
                    </div>
                  </div>
                </div>
              </Carousel>
            </div>
          </div>
          <div className="description mx-auto mt-4" style={{ width: "80%" }}>
            <p>
              Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi
              amet consectetuer lorem ipsum dolor ngồi amet consectetuer lorem
              ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi amet
              consectetuer lorem ipsum dolor ngồi amet consectetuer lorem ipsum
              dolor ngồi amet consectetuer lorem ipsum dolor{" "}
            </p>
          </div>
          <button>Contact us</button>
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonal;
